import {
  LIST_VIEW_STAR
} from 'permissions/actions'

export const EMAIL_SEQUENCE = '@@permissions/policy/email_sequence'

export default {
  [LIST_VIEW_STAR]: (user, options) => !user.read_only
}
